<template>
  <section class="greet">
    <img
      v-if="isMobile"
      class="greet__video--fallback hidden--md img-responsive"
      :src="videoImg"
    />
    <video
      v-else
      ref="backgroundMainVideo"
      class="greet__video hidden--md"
      width="100%"
      height="auto"
      autoplay
      loop
      muted
    >
      <source
        src="/static/img/geobeta/videos/geobeta-loop.webm"
        type="video/webm"
      />
      <source
        src="/static/img/geobeta/videos/geobeta-loop.mp4"
        type="video/mp4"
      />
      <div style="height: 650px; width: 100%"></div>
    </video>

    <div class="greet__background-mobile show--md"></div>

    <div class="greet__content">
      <h1 class="greet__header">
        <div class="greet__header-big">MINI DAYZ 2</div>
        <div class="greet__header-small">PLAY FOR FREE!</div>
      </h1>
      <div class="greet__play">
        <play-buttons
          :apple-link-override="
            'https://apps.apple.com/cz/app/mini-dayz-2/id1482111801'
          "
          :google-link-override="
            'https://play.google.com/store/apps/details?id=com.bistudio.mdz2'
          "
          :apple-only="false"
          class="greet__play-button-wrap"
        />
      </div>
      <img
        class="greet__video-button"
        src="static/img/geobeta/icons/play-arrow.svg"
        alt=""
        @click="showModal(4)"
      />
    </div>

    <social-widget></social-widget>
  </section>
</template>
<script>
import SocialWidget from "../SocialWidget.vue";
import PlayButtons from "../common/PlayButtons";

import videoImg from "../../../assets/img/video.jpg";

export default {
  components: {
    "social-widget": SocialWidget,
    "play-buttons": PlayButtons
  },
  data() {
    return {
      videoImg
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.settings.isMobile;
    }
  },
  created() {
    let video = this.$refs.backgroundMainVideo;
    if (video) {
      video.play();
    }
  },
  methods: {
    showModal(screenNum) {
      this.$emit("show-modal", screenNum);
    }
  }
};
</script>
